<template>
<!-- <v-scale-screen width="1920" height="1080"> -->
  <nav-header></nav-header>
  <router-view v-wechat-title="$route.meta.title"></router-view>
  <nav-footer></nav-footer>
<!-- </v-scale-screen> -->
</template>

<script>
// import VScaleScreen from 'v-scale-screen'
import NavHeader from './navHeader.vue'
import NavFooter from './navFooter.vue'
export default {
  name: 'App',
  components: {
    NavHeader,
    NavFooter
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
